import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

//----- store
import { deleteEnrollmentRequest } from "../../store/MyCourses-actions";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./TableRequests.module.css";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableRequests = (props) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const history = useHistory();

	const isLoading = useSelector((state) => state.uiData.isLoading[8]);

	const apiConfigData = useSelector((state) => state.apiConfigData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const iconButtonClickHandler = (item) => {
		// console.log("DELETE REQUEST", item.id);
		// console.log("DELETE REQUEST", item);

		const url_data =
			apiConfigData.endpoint.domain +
			"/api/FrontOffice/EnrollmentRequest";
		let url_endpoint = "";

		if (item.trainingType === "Enumerable.TrainingType.Program") {
			// Curso
			// url_data += apiConfigData.endpoint.courseEnrollRequest;
			url_endpoint = "/Program/" + item.id;
		}
		if (item.trainingType === "Enumerable.TrainingType.Class") {
			// Modulo
			// url_data += apiConfigData.endpoint.moduleEnrollRequest;
			url_endpoint = "/Course/" + item.id;
		}
		console.log(url_data + url_endpoint);

		dispatch(deleteEnrollmentRequest(url_data, url_endpoint, autenticationData));
	};

	return (
		<div className={Styles["TableRequests"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Nome</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Tipo</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>
								Data do Pedido
							</div>
						</TableCell>
						{/* <TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Metodologia</div>
						</TableCell> */}
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Estado</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}></div>
						</TableCell>
					</TableRow>
				</TableHead>
				{!isLoading && props.TableRequestsData.length > 0 && (
					<TableBody>
						{props.TableRequestsData.map((row) => (
							<TableRow
								key={row.id}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
								>
									<div className={Styles["subtitle"]}>
										{row.targetTrainingName}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.trainingType ===
										"Enumerable.TrainingType.Program"
											? "Curso"
											: "Módulo"}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.requestDateStr}
									</div>
								</TableCell>
								{/* <TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{"* em falta"}
								</div>
							</TableCell> */}
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{/* <div
										className={`${Styles["state"]} ${Styles["green"]}`}
									></div> */}
										{row.enrollmentRequestStatus &&
											row.enrollmentRequestStatus.name}
									</div>
								</TableCell>
								<TableCell
									className={`${Styles["MuiTableCell-root"]} ${Styles["MuiTableCell-icon"]}`}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										<IconButton
											aria-label="forward"
											onClick={iconButtonClickHandler.bind(
												null,
												row
											)}
											disabled={row.enrollmentRequestStatus && row.enrollmentRequestStatus.id !== 2 ? true : false}
										>
											<Icon
												style={{ fontSize: "2.5rem" }}
											>
												delete_forever
											</Icon>
										</IconButton>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				)}
			</Table>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{props.TableRequestsData.length == 0 && (
				<div className={Styles["no-record-found"]}>
					Não foi encontrado nenhum registo
				</div>
			)}
		</div>
	);
};

export default TableRequests;
